(() => {
  const MINIMUM = 4;

  const handleize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const normalizeQuantity = (input, announce = false) => {
    if (!input) return true;
    const quantity = Number.parseInt(input.value, 10);
    if (Number.isFinite(quantity) && quantity >= MINIMUM) return true;
    input.value = MINIMUM;
    if (announce) {
      const message = input.closest('form')?.querySelector('[data-rumiloo-minimum-message]');
      if (message) {
        message.textContent = 'Minimum purchase is 4 pieces per selected color.';
        message.focus({ preventScroll: true });
      }
    }
    return false;
  };

  const filterGallery = (color) => {
    if (!window.jQuery || !window.jQuery.fn?.slick) return false;
    const slug = handleize(color);
    if (!slug) return false;
    const $featured = window.jQuery('#proFeaturedImageZoom');
    const $thumbs = window.jQuery('#productThumbs .thumblist');
    if (!$featured.length || !$featured.hasClass('slick-initialized')) return false;

    $featured.slick('slickUnfilter');
    $featured.slick('slickFilter', `[data-media-color="${slug}"]`);
    $featured.slick('slickGoTo', 0, true);

    if ($thumbs.length && $thumbs.hasClass('slick-initialized')) {
      $thumbs.slick('slickUnfilter');
      $thumbs.slick('slickFilter', `[data-media-color="${slug}"]`);
      $thumbs.slick('slickGoTo', 0, true);
    }
    return true;
  };

  const selectedColor = () => document.querySelector('product-variant-swatch input:checked, product-variant-dropdown select')?.value;

  const initializeGallery = (attempt = 0) => {
    if (filterGallery(selectedColor())) return;
    if (attempt < 30) window.setTimeout(() => initializeGallery(attempt + 1), 100);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('.rumiloo-placemat-quantity, .cart__qty-input[data-rumiloo-minimum="4"]')) {
      normalizeQuantity(event.target, true);
    }
    if (event.target.matches('product-variant-swatch input, product-variant-dropdown select')) {
      window.setTimeout(() => filterGallery(event.target.value), 0);
    }
  });

  document.addEventListener('submit', (event) => {
    const input = event.target.querySelector('.rumiloo-placemat-quantity');
    if (input && !normalizeQuantity(input, true)) event.preventDefault();
    const invalidCartInput = [...event.target.querySelectorAll('.cart__qty-input[data-rumiloo-minimum="4"]')]
      .find((item) => !normalizeQuantity(item, true));
    if (invalidCartInput) event.preventDefault();
  }, true);

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('.quick_view-qty-minus, .js-qty__adjust--minus');
    const input = minus?.parentElement?.querySelector('input[type="number"]');
    if (input?.dataset.rumilooMinimum === String(MINIMUM) && Number(input.value) <= MINIMUM) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = MINIMUM;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.rumiloo-placemat-quantity, .cart__qty-input[data-rumiloo-minimum="4"]').forEach((input) => normalizeQuantity(input));
    initializeGallery();
  });
})();
